import { Component, Prop, Watch } from "vue-property-decorator";
import { InputOption } from "../../../../models/Input";
import InputDefaultForm from "../../default/InputDefaultForm";

@Component
export default class InputTextForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();
		this.$forceUpdate();
	}

	public keydown(): void {
		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputText/InputTextForm.ts